import { computed, observable, makeObservable } from 'mobx';
import {payPeriodsPerYear} from 'shared/constants';
import numeral from 'numeral';
import {formatCurrency} from 'shared/core';

class EarningsFormatter {
  model;

  constructor(model) {
    makeObservable(this, {
      model: observable,
      annualizedSalary: computed,
      formattedBaseInsurableEarnings: computed,
      formattedAnnualizedCommission: computed,
      formattedTotalInsurableEarnings: computed
    });

    this.model = model;
  }

  get annualizedSalary() {
    return payPeriodsPerYear(this.model.payRateUnit, this.model.hoursPerWeek) * numeral(this.model.payRate).value();
  }

  get formattedBaseInsurableEarnings() {
    return formatCurrency(this.model.payRateCurrency, this.annualizedSalary);
  }

  get formattedAnnualizedCommission() {
    return formatCurrency(this.model.payRateCurrency, numeral(this.model.annualizedCommission).value());
  }

  get formattedTotalInsurableEarnings() {
    const totalEarnings = this.annualizedSalary + numeral(this.model.annualizedCommission).value();

    return formatCurrency(this.model.payRateCurrency, totalEarnings);
  }
}

export default EarningsFormatter;
